/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import { createStore, combineReducers } from 'redux';
import PropTypes, { any } from 'prop-types';
import get from 'lodash/get';
import take from 'lodash/take';
import unescape from 'lodash/unescape';
import { isMobile } from 'react-device-detect';
import { checkCookie, getStaticConfig, syndicatedSource, truncate } from '../../helpers/utils';
import StoryBaseTemplate from './story-base-template';
import storyElementWithCustomTemplates from '../story/story-elements/index';
import MarketBox from '../story/market-box/market-box';
import WithMember from '../hoc/with-member';
import AdWithPlaceholder from '../molecules/ad-with-placeholder';
import reducers from '../../../store/reducers';
import PremiumStory from './premium-story';

const getPartialContent = (cards = []) => {
  const storyCards = take(cards);

  const partialStory = storyCards.map(card => {
    const storyCard = Object.assign({}, card);
    const storyElements = take(storyCard['story-elements']);
    if (storyElements[0].type === 'text') {
      storyElements[0] = Object.assign({}, storyElements[0]);
      storyElements[0].text = truncate(
        unescape(storyElements[0].text.replace(/<[^>]+>/g, '')),
        440
      );
    }

    storyCard['story-elements'] = storyElements;

    return storyCard;
  });

  return partialStory;
};

function changeSymbolColor(element) {
  const newElement = { ...element };
  if (newElement.type === 'text') {
    newElement.text = newElement.text.replace(/♥|♦/gi, function (matched) {
      return `<span style="color:red;">${matched}</span>`;
    });
  }
  return newElement;
}

const renderCards = (story = {}, storyCards = [], preview = false) => {
  const cardLength = storyCards.length;

  return (
    <React.Fragment>
      {storyCards.map((card, index) => {
        const cardAttributeTemplate = get(card, ['metadata', 'attributes', 'template', 0], '');
        const cardAttributeTicker = get(card, ['metadata', 'attributes', 'ticker'], []);
        const classes = cardAttributeTemplate ? `story-card-${cardAttributeTemplate}` : '';
        const storyStyleType = get(story, ['metadata', 'story-attributes', 'storystyletype', 0]);
        const storyElements = card['story-elements'];

        return (
          <React.Fragment key={card.id}>
            <div
              id={`card-${card.id}`}
              key={card.id}
              className={`${classes} paywall print-story-card`}
            >
              {cardAttributeTicker.length ? (
                <WithMember>
                  {({ checkForMemberUpdated }) => (
                    <MarketBox
                      reloadMember={checkForMemberUpdated}
                      entities={cardAttributeTicker}
                    />
                  )}
                </WithMember>
              ) : null}
              {storyElements.map((element, index) => {
                const storyElement =
                  storyStyleType === 'cards' ? changeSymbolColor(element) : element;

                return (
                  <>
                    {storyElementWithCustomTemplates(
                      card,
                      storyElement,
                      story,
                      cardAttributeTemplate
                    )}
                  </>
                );
              })}
            </div>

            {index === storyCards.length - 2 && (
              <div id="cx_d69ed4036eaf920b54b9197a41ccf409bbd261b3"></div>
            )}
            {index === Math.round(cardLength / 2) - 1 && !preview ? (
              <>
                {/* <div className="responsive-ad content-center mobile-only">
                  <AdWithPlaceholder adtype="ScrollViewArticlePageMobile" height="100px" />
                </div>
                <div className="responsive-ad content-center desktop-only">
                  <AdWithPlaceholder adtype="RevealArticlePage" height="90px" />
                </div> */}
              </>
            ) : (
              ''
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

const BlankStory = ({
  story,
  partialAccess,
  updateAccess,
  isLoading,
  privateMode,
  mostRead,
  qt,
  subscriberStatus
}) => {
  const { cards } = story;
  const storyCards = partialAccess ? getPartialContent(cards) : cards;
  let config = {
    config: {
      'cdn-image': 'gumlet.assettype.com'
    }
  };

  config = {
    ...config,
    ...qt
  };

  const rootReducer = combineReducers({
    ...reducers,
    qt: (state = config, action) => state
  });
  const store = createStore(rootReducer);
  const [isSubscriber, setIsSubscriber] = useState(false);
  const [isGeoBlock, setIsGeoBlock] = useState(false);

  useEffect(() => {
    const paragraphs = document.getElementsByTagName('p');
    let filteredCount = 0;
    for (let index = isMobile ? 1 : 2; index < paragraphs.length - 1; index++) {
      if (
        document.getElementsByTagName('p')[index].parentElement?.tagName !== 'LI' &&
        document.getElementsByTagName('p')[index].parentElement?.className !== 'paragraphs'
      ) {
        document.getElementsByTagName('p')[index].className = 'filteredParagraphs';
        filteredCount++;
      }
    }

    let adNumber = 0;
    const adLimit = isMobile ? 3 : 3;

    if (isMobile) {
      for (let i = 0; i < filteredCount; i += 2) {
        if (adNumber < adLimit) {
          adNumber++;
          const id = `MobilePara${i}`;
          const d = document.createElement('div');
          d.id = id;
          d.className = 'responsive-ad content-center';
          document.getElementsByClassName('filteredParagraphs')[i]?.appendChild(d);
          ReactDOM.render(
            <>
              <Provider store={store}>
                <AdWithPlaceholder
                  height="280px"
                  width="336px"
                  adUnit={adNumber === 1 ? 'Mid_300x250_1' : `Mid_300x250_${adNumber}`}
                  sizes={[[336, 280], [300, 250]]}
                />
              </Provider>
            </>,
            document.getElementById(id)
          );
        }
      }
    } else {
      for (let i = 0; i < filteredCount; i += 3) {
        if (adNumber < adLimit) {
          adNumber++;
          const id = `Para${i}`;
          const d = document.createElement('div');
          d.id = id;
          d.className = 'responsive-ad content-center';
          document.getElementsByClassName('filteredParagraphs')[i]?.appendChild(d);
          ReactDOM.render(
            <>
              <Provider store={store}>
                <AdWithPlaceholder
                  height="90px"
                  width="728px"
                  adUnit={`Mid_728x90_${adNumber}`}
                  sizes={[[728, 90]]}
                />
              </Provider>
            </>,
            document.getElementById(id)
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      var cX = window.cX || {};
      cX.callQueue = cX.callQueue || [];
      cX.CCE = cX.CCE || {};
      cX.CCE.callQueue = cX.CCE.callQueue || [];
      cX.CCE.callQueue.push([
        'run',
        {
          // widgetId: 'bf408317f0c33e3364ff451f5103055d380fba1a',
          targetElementId: 'recomended-for-you-piano'
        }
      ]);
    }, 3000);

    // geoblock
    const GeoTag = checkCookie('GeoTag');
    const syndicatesource = syndicatedSource(story);
    const sectionSlug = get(story, ['sections']).map(item => item.slug);
    const sources = get(
      getStaticConfig,
      ['integrations', 'geoTag', 'sources'],
      ['Bloomberg', 'businessweek', 'bloomberg']
    );
    const sourceCheck =
      sources.includes(syndicatesource) || sectionSlug.some(val => sources.includes(val));
    setIsGeoBlock(GeoTag && GeoTag !== 'undefined' && GeoTag !== 'IN' && sourceCheck);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    !isSubscriber && setIsSubscriber(subscriberStatus);
  }, [subscriberStatus]);

  return (
    <>
      {isSubscriber ? (
        <PremiumStory
          story={story}
          content={renderCards(story, storyCards)}
          previewContent={renderCards(story, getPartialContent(cards), true)}
          partialAccess={partialAccess}
          updateAccess={updateAccess}
          isLoading={isLoading}
          privateMode={privateMode}
          mostRead={mostRead}
        />
      ) : (
        <StoryBaseTemplate
          story={story}
          content={renderCards(story, storyCards)}
          previewContent={renderCards(story, getPartialContent(cards), true)}
          partialAccess={partialAccess}
          updateAccess={updateAccess}
          isLoading={isLoading}
          privateMode={privateMode}
          mostRead={mostRead}
        />
      )}
    </>
  );
};

BlankStory.propTypes = {
  story: PropTypes.objectOf(PropTypes.any).isRequired,
  partialAccess: PropTypes.bool,
  updateAccess: PropTypes.func,
  isLoading: PropTypes.bool,
  privateMode: PropTypes.bool,
  mostRead: PropTypes.object,
  qt: any
};

const mapStateToProps = state => ({
  qt: get(state, ['qt'], ''),
  subscriberStatus: get(state, ['isSubscriber', 'isSubscriber'])
});

export default connect(mapStateToProps, () => ({}))(BlankStory);
